module.exports = "{\r\n  \"campaign\": {\r\n    \"utm_source\": \"utm_source\",\r\n    \"utm_medium\": \"utm_medium\",\r\n    \"utm_term\": \"utm_term\",\r\n    \"utm_content\": \"utm_content\",\r\n    \"utm_campaign\": \"utm_campaign\"\r\n  }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/js/portal/config/campaignUrlParams.json
// module id = 496
// module chunks = 0